export default "__VITE_ASSET__B7$K8cer__$_?format=webp__"